// extracted by mini-css-extract-plugin
export default {"phoneWrapper":"OPUGAmTvZzmIz55BgHeb","phoneInputWrapper":"Yv97XM44y_NfxLnghng3","phoneErrorWrapper":"wH4a9sNJsdkX8xhdemkt"};